(function notificationConfigControllerDefinition() {
    'use strict';

    angular.module('NotificationConfig')
        .controller('NotificationConfigDetailController', [
            '$scope', 'config', '$state', '$stateParams', '$translate', 'errorsExtend', 'authExtend', '$filter', 'adminNotificationConfigService', 'documentTypeService', 'adminRoleService',
            function NotificationConfigDetailController($scope, config, $state, $stateParams, $translate, errors, authExtend, $filter, adminNotificationConfigService, documentTypeService, adminRoleService) {
                $scope.canConfigApps = authExtend.isInRole('CONFIG ADMIN APPS');

                $scope.load = function () {
                    $scope.optionsTimes = [{ name: "antes" }, { name: "después" }];
                    $scope.metadataAccordionOpened = true;

                    adminNotificationConfigService.getById($stateParams.id).then(function (result) {
                        $scope.notificationConfig = result;

                        //Define config type
                        $translate(['NotificationConfigTypePublish', 'NotificationConfigTypeDate'])
                            .then(function (translated) {
                                if ($scope.notificationConfig.metadataId) {
                                    $scope.notificationConfig.configType = translated.NotificationConfigTypeDate;
                                    $scope.notificationConfig.configurationTypeId = 2;
                                }
                                else {
                                    $scope.notificationConfig.configType = translated.NotificationConfigTypePublish;
                                    $scope.notificationConfig.configurationTypeId = 1;
                                }
                            });


                        $scope.notificationConfig.time = result.daysToNotification < 0 ? $scope.optionsTimes[0] : $scope.optionsTimes[1];
                        $scope.notificationConfig.daysToNotification = Math.abs(result.daysToNotification) + ' dias ' + $scope.notificationConfig.time.name;

                        $scope.documentType = {
                            metadatas: []
                        }

                        if ($scope.notificationConfig.metadatas.length > 0) {
                            
                            $scope.notificationConfig.metadatas.forEach(function (metadata) {
                                if (!metadata.allValues) {
                                    var values = JSON.parse(metadata.values);
                                    var v = [];

                                    values.forEach(function (val) {
                                        v.push(val.value);
                                    });

                                    metadata.values = v.join(", ");
                                }
                        
                                $scope.documentType.metadatas.push(metadata);
                            });
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                }

                $scope.cancel = function () {
                    $state.go('notification-config-find');
                };

                $scope.load();
            }
        ]);
})();